import React, { lazy } from "react";
import { Route } from "react-router-dom";

const RouteWrapper = lazy(() => import("./routeWrapper"));

const TravelRequestTab = lazy(() => import("../pages/genericTableData/travelrequesttab"));
const TravelTab = lazy(() => import("../pages/traveltab"));
const GenericPendingPage = lazy(() => import("../pages/genericpendingpage"));
const ControlledUserRequests = lazy(() => import("../pages/controlledUserRequests"));

const TravelRequestRoutes = [
    <RouteWrapper
        exact
        path={["/history/travel", "/pending/travel", "/others/alltravel"]}
        layout={TravelRequestTab}
        routes={[
            <Route
                exact
                path={["/history/travel", "/history/travel/:id", "/history/travel/:id/:tripId"]}
                component={TravelTab}
            />,
            <Route exact path="/pending/travel" component={GenericPendingPage} />,
            <Route exact path="/others/alltravel" component={ControlledUserRequests} />
        ]}
    />
];

export default TravelRequestRoutes;
